module.exports = __webpack_public_path__ + "img/italy-cardiovascular-diseases-male.8e57cd07.png";